import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchParticipants = createAction(constants.FETCH_PARTICIPANTS)
export const fetchParticipantsPending = createAction(constants.FETCH_PARTICIPANTS_PENDING)
export const fetchParticipantsFailed = createAction(constants.FETCH_PARTICIPANTS_FAILED)
export const fetchParticipantsCancelled = createAction(constants.FETCH_PARTICIPANTS_CANCELLED)
export const receiveParticipants = createAction(constants.RECEIVE_PARTICIPANTS)

export const addParticipants = createAction(constants.ADD_PARTICIPANTS)
export const addParticipantsPending = createAction(constants.ADD_PARTICIPANTS_PENDING)
export const addParticipantsFailed = createAction(constants.ADD_PARTICIPANTS_FAILED)
export const addParticipantsSuccess = createAction(constants.ADD_PARTICIPANTS_SUCCESS)

export const removeParticipants = createAction(constants.REMOVE_PARTICIPANTS)
export const removeParticipantsPending = createAction(constants.REMOVE_PARTICIPANTS_PENDING)
export const removeParticipantsFailed = createAction(constants.REMOVE_PARTICIPANTS_FAILED)
export const removeParticipantsSuccess = createAction(constants.REMOVE_PARTICIPANTS_SUCCESS)

export const setModalVisibility = createAction(constants.SET_MODAL_VISIBILITY)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/participants/actions.js